import { ToggleButtonGroup } from "@mui/material"
import { Repeat } from "lib/@components/repeat"
import { SkillMapViewModeOption } from "./skill-map-view-mode-option"

/**
 * Chooses between Skill routing and the views plugged into SkillMapViewModes.
 *
 * @param {{ options: Array<{ value: string, label: string }>, value: string, onChange: (value: string) => void }} props
 */
export function SkillMapViewModeToggle({ options, value, onChange }) {
    return (
        <ToggleButtonGroup exclusive size="small" value={value} onChange={handleChange} data-cy="skill-map-view-toggle">
            <Repeat list={options} item={<SkillMapViewModeOption />} keyFn={toValue} />
        </ToggleButtonGroup>
    )

    function handleChange(__, next) {
        // Exclusive toggle groups report null when the active button is clicked again
        if (next) onChange(next)
    }
}

function toValue(option) {
    return option.value
}
